export const PHONE_NUMBERS = ["+40 742 689 717", "+40 751 885 792"];
export const EMAIL = "balintalpar91@gmail.com";
export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=100043559239691";

export const toTelHref = (phone) => `tel:${phone.replace(/\s/g, "")}`;

export const toMapsHref = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address
  )}`;
